import { render, staticRenderFns } from "./reglas.vue?vue&type=template&id=617ec7d9&scoped=true"
import script from "./reglas.vue?vue&type=script&lang=js"
export * from "./reglas.vue?vue&type=script&lang=js"
import style0 from "./reglas.vue?vue&type=style&index=0&id=617ec7d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617ec7d9",
  null
  
)

export default component.exports